import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Rx'

import { OperationServiceAdapter } from '../operation'
import { JsonApiProcessor } from '../operation/operation-processors'
import { TestExecution, ScoreResult } from '../../models'

@Injectable()
export class ScoreResultService extends OperationServiceAdapter<ScoreResult> {
  constructor(
    private _processor: JsonApiProcessor
  ) {
    super(_processor, ScoreResult)
  }

  public score(execution: TestExecution): Observable<ScoreResult> {
    return this.callPostOperation('score', { testExecution: execution })
      .do(() => execution.status = 'finished') as Observable<ScoreResult>
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/score-result/score-result.service.ts